import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Description = styled(Typography)(() => ({
  margin: '16px auto 32px auto',
  maxWidth: '490px',
}));
